import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTodos: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"todos,check,things, task"} maskId="square-filled-radius-0-stroke-1-IconTodos"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H15V20H9V21H3V3ZM16.4448 8.36855L15.6186 7.80522L10.8862 14.746L8.21218 12.3439L7.54391 13.0878L11.0684 16.254L16.4448 8.36855Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconTodos;
